module.exports = __webpack_public_path__ + "img/built_on_blockly.2f01100d.png";